module.exports = __webpack_public_path__ + "static/media/ic_profile_border.aabc3217.svg";